var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['layout-mask', { 'is-active': _vm.isActive }]})}
var staticRenderFns = []

export { render, staticRenderFns }